<rk-mobile-close-button class="fixed z-10" (click)="exitPanel()"></rk-mobile-close-button>
<ng-container *ngIf="currentRadioId$ | async as radioId">
  <div class="p-5">
    <rk-page-title [title]="'MEDIA.PLAYLISTS.TITLE_MINE' | translate"></rk-page-title>
    <rk-search-bar (inputted)="search($event)" [type]="'full'"></rk-search-bar>
  </div>
  <div class="section-title" translate>SCHEDULE.PLANNING.EDIT_MODAL_TAB_PLAYLIST</div>
  <div class="list playlist-list pb-1 bg-white overflow-auto">
    @for (playlist of playlists; track playlist; let i = $index) {
      <div
        class="link"
        (click)="clickPlaylist(playlist.id)"
        (touchstart)="onTouch(i + 10)"
        (touchmove)="onTouchEnd()"
        (touchend)="onTouchEnd()"
        [class.touched]="$touched() === i + 10"
      >
        <rk-playlist-icon [playlist]="playlist"></rk-playlist-icon>
        <span class="ellipsis">{{ playlist.name }}</span>
      </div>
    } @empty {
      <div class="p-5 gap-2 flex flex-col items-center justify-center">
        <img src="/assets/search-empty.svg" alt="" />
        <div class="text-base">
          {{
            'MEDIA.TABLE.SEARCH_EMPTY' | translate: { search: searchSubject.getValue() }
          }}
        </div>
      </div>
    }
  </div>
</ng-container>
